import React from "react";
import Image from "../assets/journey 3.png";
import "aos/dist/aos.css";
import AOS from "aos";

const Journey = () => {
  AOS.init();
  return (
    <div className="bg-[#FAEBCC] px-20 md:pt-20 pt-36 pb-20 overflow-hidden">
      <h1 className="text-6xl flex justify-center pt-10" data-aos="fade-right" data-aos-duration="2000">
        <span className="px-2 font-dancing">Our </span> Journey
      </h1>
      <div className="flex md:flex-row flex-col pt-10 justify-center items-center border-b-2 border-dashed border-yellow-700 gap-10 pb-10">
        <div className="flex md:flex-row flex-col justify-center items-center gap-4  " data-aos="fade-right"  data-aos-duration="1500">
          <div>
            <img src={Image} alt=""></img>
            <h1 className="text-2xl text-red-800 md:ml-16">2012</h1>
          </div>
          <div className="">
            <p className="md:w-80 w-64 mt-6 ">
            Started the Krisoft with a small team of passionate marketers. 
            </p>
          </div>
        </div>
        <div className="flex md:flex-row flex-col justify-center items-center  gap-4" data-aos="fade-left"  data-aos-duration="1500">
          <div>
            <img src={Image} alt=""></img>
            <h1 className="text-2xl text-red-800 md:ml-16">2020</h1>
          </div>
          <div className="">
            <p className="md:w-80 w-64 mt-6 ">
            Within 6 years, we established a strong business for several MNCs and big brands. 
            </p>
          </div>
        </div>
      </div>
      <div className="flex md:flex-row flex-col pt-10 justify-center items-center gap-10 ">
        <div className="flex md:flex-row flex-col justify-center items-center gap-2 "data-aos="fade-right"  data-aos-duration="1500">
          <div className="">
            <p className="md:w-80 w-64 mt-6">
            Achieving the bigger picture, we made our way to the companies and brands internationally. 
            </p>
          </div>
          <div>
            <h1 className="text-2xl text-red-800 md:ml-16 ml-0">2018</h1>
            <img className="w-[187px] h-[148px]" src={Image} alt=""></img>
          </div>
        </div>
        <div className="flex md:flex-row flex-col  justify-center items-center " data-aos="fade-left"  data-aos-duration="1500">
          <div className="">
            <p className="md:w-80 w-64 mt-6">
            Today, we have worked with numerous Fortune 500 companies and continue to achieve the best in the digital age. 
            </p>
          </div>
          <div>
            <h1 className="text-2xl text-red-800 md:ml-16">2024</h1>
            <img src={Image} alt=""></img>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Journey;
